import { render, staticRenderFns } from "./InfoCompetence.vue?vue&type=template&id=5d2d8d72&scoped=true"
import script from "./InfoCompetence.vue?vue&type=script&lang=js"
export * from "./InfoCompetence.vue?vue&type=script&lang=js"
import style0 from "./InfoCompetence.vue?vue&type=style&index=0&id=5d2d8d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2d8d72",
  null
  
)

export default component.exports